import { render, staticRenderFns } from "./RecipeAlterFoodForm.vue?vue&type=template&id=ab560660&scoped=true"
import script from "./RecipeAlterFoodForm.vue?vue&type=script&lang=js"
export * from "./RecipeAlterFoodForm.vue?vue&type=script&lang=js"
import style0 from "./RecipeAlterFoodForm.vue?vue&type=style&index=0&id=ab560660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab560660",
  null
  
)

export default component.exports